import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13d6a71e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=13d6a71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6a71e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Button/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
